module.exports = __webpack_public_path__ + "img/app_icon.77d14532.png";